"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
const ConsentStore_1 = require("./ConsentStore");
class DealerConsentStore {
    constructor(rootStore) {
        Object.defineProperty(this, "allConsentSigners", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "allSignaturesValid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "employeeSignatureValueFromDatabase", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "confirmLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "employeeSignature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "wasSignatureChanged", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "init", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.ssoStore.isDealer) {
                    return this.getConsentSigners();
                }
            }
        });
        Object.defineProperty(this, "prepareSignableConsents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (templateCode) => {
                await this.postPrepareConsents(templateCode);
            }
        });
        Object.defineProperty(this, "confirmAllCurrentSignableConsents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.confirmLoading = true;
                await Promise.all(this.consentStore.changedConsents.map((e) => ApiUtil_1.default.post('/consent/sign/on-screen', this.getPostOnScreenSignaturesData(e), { timeout: 30000 })));
                if (this.wasSignatureChanged) {
                    await this.postEmployeeSignature(this.signatureToBase64(this.employeeSignature));
                    this.employeeSignatureValueFromDatabase = this.signatureToBase64(this.employeeSignature);
                    this.wasSignatureChanged = false;
                    this.employeeSignature.off();
                }
                this.confirmLoading = false;
            }
        });
        Object.defineProperty(this, "setError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.isError = true)
        });
        Object.defineProperty(this, "unsetError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.isError = false)
        });
        (0, mobx_1.makeObservable)(this);
        this.ssoStore = rootStore.ssoStore;
        this.consentStore = rootStore.consentStore;
        (0, mobx_1.reaction)(() => this.ssoStore.initStores, this.init);
    }
    async initSignatureValue() {
        this.employeeSignatureValueFromDatabase = await this.fetchEmployeeSignature();
        if (this.employeeSignatureValueFromDatabase) {
            this.employeeSignature.off();
            this.employeeSignature.fromDataURL(this.employeeSignatureValueFromDatabase, {});
        }
    }
    createConsentResources() {
        return this.consentStore.changedConsents.map((consent) => ({
            value: consent.allowed,
            type: consent.type
        }));
    }
    mapSignersToResources() {
        return this.selectedConsentSigners.map((signer) => ({
            personalCode: signer.personalCode,
            personalCodeCountryCode: signer.personalCodeCountryCode,
            signature: this.signatureToBase64(signer.signature)
        }));
    }
    getSignableConsentsData(templateCode) {
        const signers = this.selectedConsentSigners.map((signer) => ({
            personalCode: signer.personalCode,
            personalCodeCountryCode: signer.personalCodeCountryCode
        }));
        const data = {
            consents: this.createConsentResources(),
            externalPartySigners: signers,
            templateCode
        };
        return data;
    }
    getPostOnScreenSignaturesData(consent) {
        if (!this.wasSignatureChanged) {
            return {
                jwt: consent.linksJwt,
                externalPartySigners: this.mapSignersToResources(),
                employeeSignature: this.employeeSignatureValueFromDatabase
            };
        }
        else {
            return {
                jwt: consent.linksJwt,
                externalPartySigners: this.mapSignersToResources(),
                employeeSignature: this.signatureToBase64(this.employeeSignature)
            };
        }
    }
    handlePrepareSignableConsentsResponse(consents) {
        const trafficDataAnalysis = consents.find((c) => c.type === ConsentStore_1.ConsentType.TRAFFIC_DATA_ANALYSIS);
        const directMarketing = consents.find((c) => c.type === ConsentStore_1.ConsentType.DIRECT_MARKETING);
        const locationDataAnalysis = consents.find((c) => c.type === ConsentStore_1.ConsentType.LOCATION_DATA_ANALYSIS);
        if (trafficDataAnalysis) {
            this.consentStore.updateConsentLinksJwt(ConsentStore_1.ConsentType.TRAFFIC_DATA_ANALYSIS, trafficDataAnalysis.linksJwt);
        }
        if (directMarketing) {
            this.consentStore.updateConsentLinksJwt(ConsentStore_1.ConsentType.DIRECT_MARKETING, directMarketing.linksJwt);
        }
        if (locationDataAnalysis) {
            this.consentStore.updateConsentLinksJwt(ConsentStore_1.ConsentType.LOCATION_DATA_ANALYSIS, locationDataAnalysis.linksJwt);
        }
    }
    signatureToBase64(signature) {
        return signature.toDataURL('image/svg+xml', {});
    }
    validateSignatures() {
        const employeeSignatureValid = this.employeeSignature && !this.employeeSignature.isEmpty();
        const signerSignaturesValid = this.selectedConsentSigners.every((s) => s.signature && !s.signature.isEmpty());
        this.allSignaturesValid = employeeSignatureValid && signerSignaturesValid;
    }
    fetchEmployeeSignature() {
        return ApiUtil_1.default.get('/employee-signature').then((response) => response.data.signatureImage);
    }
    postEmployeeSignature(employeeSignatureCreation) {
        return ApiUtil_1.default.post('/employee-signature', { signatureImage: employeeSignatureCreation });
    }
    deleteEmployeeSignature() {
        ApiUtil_1.default.delete('/employee-signature');
    }
    get currentSignableConsent() {
        const consents = this.consentStore.changedConsents;
        if (consents.length > 0) {
            return this.consentStore.changedConsents[0];
        }
        return null;
    }
    get showConsentSignersModal() {
        return this.ssoStore.isDealer && this.ssoStore.isBusinessCustomer && this.allConsentSigners.length > 1 && !this.isError;
    }
    get latestEmployeeSignature() {
        return this.wasSignatureChanged ? this.signatureToBase64(this.employeeSignature) : this.employeeSignatureValueFromDatabase;
    }
    get selectedConsentSigners() {
        return this.allConsentSigners.filter((signer) => signer.selected);
    }
    async wrapConsentActionWithErrorHandling(method, args) {
        try {
            this.unsetError();
            this.consentStore.toggleConfirmload(true);
            await method(args);
        }
        catch (_a) {
            this.setError();
            throw new Error('Failed to handle consents');
        }
        finally {
            this.consentStore.toggleConfirmload(false);
        }
    }
    async getConsentSigners() {
        const response = await ApiUtil_1.default.get('/consent/signers');
        response.data.signers.forEach((signer) => {
            if (this.ssoStore.isSamePerson(signer.personalCode)) {
                signer.selected = true;
            }
        });
        this.allConsentSigners = response.data.signers;
    }
    async postPrepareConsents(templateCode) {
        const response = await ApiUtil_1.default.post('/consent/prepare', this.getSignableConsentsData(templateCode));
        this.handlePrepareSignableConsentsResponse(response.data.consents);
    }
}
__decorate([
    mobx_1.observable
], DealerConsentStore.prototype, "allConsentSigners", void 0);
__decorate([
    mobx_1.observable
], DealerConsentStore.prototype, "allSignaturesValid", void 0);
__decorate([
    mobx_1.observable
], DealerConsentStore.prototype, "isError", void 0);
__decorate([
    mobx_1.observable
], DealerConsentStore.prototype, "employeeSignatureValueFromDatabase", void 0);
__decorate([
    mobx_1.observable
], DealerConsentStore.prototype, "confirmLoading", void 0);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "validateSignatures", null);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "fetchEmployeeSignature", null);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "postEmployeeSignature", null);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "deleteEmployeeSignature", null);
__decorate([
    mobx_1.computed
], DealerConsentStore.prototype, "currentSignableConsent", null);
__decorate([
    mobx_1.computed
], DealerConsentStore.prototype, "showConsentSignersModal", null);
__decorate([
    mobx_1.computed
], DealerConsentStore.prototype, "latestEmployeeSignature", null);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "confirmAllCurrentSignableConsents", void 0);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "wrapConsentActionWithErrorHandling", null);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "setError", void 0);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "unsetError", void 0);
__decorate([
    mobx_1.action
], DealerConsentStore.prototype, "getConsentSigners", null);
exports.default = DealerConsentStore;
